import React from 'react';
import { MyAccountLegal } from '@components/templates/myAccount/legal/MyAccountLegal';

export function MyAccountLegalPage() {
    return <MyAccountLegal />;
}

